export default "__VITE_ASSET__71e59ef5__"